<template>
<div class="control test-question-answer-options">
    <div class="test-question-answer-option-container" v-for="option of options">
        <label class="checkbox">
            <input type="checkbox" :value="option.hash_id" v-model="result">
            <span>{{ option.text }}</span>
        </label>
    </div>
</div>
</template>

<script>
export default {
name: "TestQuestionMultipleChoiceAnswer",
    props: [
        'value',
        'options',
    ],
    computed: {
        result: {
            get() {
                if (Array.isArray(this.value)) {
                    return this.value;
                }

                return [];
            },
            set(val) {
                this.$emit('input', val);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/variables';

.test-question-answer-options {
    padding: 0 15px;
}

.test-question-answer-option-container {
    padding: 17px 0;
    line-break: anywhere;

    &:not(:first-child) {
        border-top: 1px solid $tests-light-grey;
    }

    label.radio {
        display: flex;
        text-align: center;

        input[type=radio] {
            min-width: 20px;
            min-height: 20px;
            margin-right: 10px;
            align-self: center;
        }

        span {
            text-align: left;
            word-break: break-word;
        }
    }
}
</style>